import React from 'react';
import Select from 'react-select';

// Material UI
import Typography from '@material-ui/core/Typography';

// Components
import { FormInput, FormLabel, IFormOption } from '../../_core/_ui/forms.component';
import { FormControl } from '@material-ui/core';
import { getPlayerStatus } from '../../../lib/utils/player.utils';

interface IEditPlayerAssessment {
  playerAssessment?: IPlayerAssessment;
  loading: boolean,
  positionOptions: IFormOption[];
  changePosition: Function;
}

const EditPlayerAssessment: React.FC<IEditPlayerAssessment> = ({
  playerAssessment,
  loading,
  positionOptions,
  changePosition
}) => {
  if (loading) return <Typography>Loading...</Typography>;

  const playerStatus = playerAssessment ? getPlayerStatus(playerAssessment) : ""
  return (
    <div>
      <FormLabel>Position</FormLabel>
      <Select
        loading={loading}
        options={positionOptions}
        isOptionDisabled={option => option.value === playerAssessment?.position._id}
        value={{ value: playerAssessment?.position._id, label: playerAssessment?.position.name }}
        onChange={option => option && changePosition(option.value)}
      />
      {!!playerStatus &&
        <FormControl margin="normal" fullWidth component="div">
          <FormLabel htmlFor="status">Status</FormLabel>
          <FormInput
            id="status"
            type="text"
            name="status"
            disabled
            value={playerStatus}
            style={{opacity: "60%"}}
          />
        </FormControl>
      }
    </div>
  );
};

export default EditPlayerAssessment;
